import React, { useContext } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import Axios from 'axios';
import MyTextField from '../../common/MyTextField';

import pickBkgClass from '../../utils/pickBkgClass';
import MyThemeContext from '../../contexts/theme-context/ThemeProviderContext';
import ButtonWithLoading from '../../common/button-with-loading/ButtonWithLoading';
import FlashMessageContext from '../../contexts/flash-messages-context/FlashMessageProvider';
import UesrContext from '../../contexts/user-context/UserProvider';

const registerSchema = Yup.object().shape({
	username: Yup.string()
		// .trim('No leading and trailing spaces')
		// .strict(true)
		.required()
		.min(2)
		.max(12)
		.trim()
		.test('username', 'NO White spaces', value => {
			return value && !value.includes(' ');
		}),
	email: Yup.string().email().trim().required(),
	password: Yup.string()
		.min(8)
		.max(14)
		.trim('No leading or trailing spaces')
		.strict()
		.required(),
	matchPassword: Yup.string()
		.required()
		.oneOf([Yup.ref('password')], 'Password does not match')
});

const sleep = ms => new Promise(r => setTimeout(r, ms));

const RegisterForm = () => {
	const { themeName } = useContext(MyThemeContext);
	const {
		setFlashMsgIsOpen,
		setFlashMsg,
		setFlashMsgDuration,
		setNotificationSeverity
	} = useContext(FlashMessageContext);
	const { setCurrentUser } = useContext(UesrContext);

	return (
		<>
			<Formik
				initialValues={{
					username: '',
					email: '',
					password: '',
					matchPassword: ''
				}}
				onSubmit={async (values, { setSubmitting, resetForm }) => {
					await sleep(500);
					try {
						setSubmitting(true);
						// console.log('values', values);
						const castedValues = {
							...values,
							username: values.username.trim()
						};
						// console.log('casted values', castedValues);
						const response = await Axios.post('/register', {
							...castedValues
						});
						console.log('Registered user: ', response);

						if (response.status === 200 && response.data.token) {
							setSubmitting(false);
							resetForm();
							setFlashMsgIsOpen(true);
							setFlashMsg('Registered Successfully!');
							setFlashMsgDuration(4000);
							setNotificationSeverity('success');
							//
							const currentUser = response.data;
							setCurrentUser(currentUser);
						} else {
							setSubmitting(false);
							// resetForm();
							setFlashMsgIsOpen(true);
							setFlashMsg('Username or email already taken!');
							setFlashMsgDuration(4000);
							setNotificationSeverity('error');
						}
					} catch (e) {
						const isTheServerAvailable = () => {
							const timeout = new Promise((resolve, reject) => {
								setTimeout(reject, 30000, 'Request timed out');
							});

							const request = fetch('http://localhost:8080/register');

							return Promise.race([timeout, request])
								.then(response => {
									setFlashMsgIsOpen(true);
									setFlashMsg('Username or email already taken!');
									setFlashMsgDuration(4000);
									setNotificationSeverity('error');
								})
								.catch(error => {
									setFlashMsgIsOpen(true);
									setFlashMsg(error.message);
									setFlashMsgDuration(4000);
									setNotificationSeverity('error');
								});
						};

						isTheServerAvailable();
						// console.log(e.message);
					}
				}}
				validationSchema={registerSchema}
			>
				{({ values, isSubmitting, handleSubmit, errors, touched }) => (
					<form
						onSubmit={handleSubmit}
						className={`registerForm ${pickBkgClass(themeName, 'soft')}`}
						autoComplete="off"
					>
						<h2>Register Now it's free</h2>

						<MyTextField
							name="username"
							type="text"
							label="Enter Username"
							variant="outlined"
							color="primary"
						/>
						<MyTextField
							name="email"
							type="email"
							label="Enter your Email"
							variant="outlined"
							color="primary"
						/>
						<MyTextField
							name="password"
							type="password"
							label="Enter Your password"
							variant="outlined"
							color="primary"
						/>
						<MyTextField
							name="matchPassword"
							type="password"
							label="Repeat Your password"
							variant="outlined"
							color="primary"
						/>

						<ButtonWithLoading
							isSubmitting={isSubmitting}
							errors={errors}
							btnText="register"
							loadingMsg="Please Wait.."
						/>

						{/* <pre>{JSON.stringify(values, null, 2)}</pre>
						<pre>{JSON.stringify(errors, null, 2)}</pre>
						<pre>{JSON.stringify(touched, null, 2)}</pre> */}
					</form>
				)}
			</Formik>
		</>
	);
};

export default RegisterForm;
